import React from "react";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";
import { ERAS } from "../data/resume";
import { SCENES, sceneEnd } from "../data/scenes";

// Persistent 2018 ▸▸▸ 2026 progress indicator pinned to the bottom of the
// composition. Rendered at the composition root so useCurrentFrame() is the
// global playhead.
const TimelineHUD: React.FC = () => {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  // Career span mapped onto the scene frames that tell it: zip → senior era.
  const trackStart = SCENES.zip.from;
  const trackEndFrame = sceneEnd("seniorEra");
  const eraStops = [
    { color: ERAS[0].color, from: SCENES.zip.from, to: sceneEnd("zip") },
    {
      color: ERAS[1].color,
      from: SCENES.paloDeck.from,
      to: sceneEnd("paloDeck"),
    },
    {
      color: ERAS[2].color,
      from: SCENES.fourMation.from,
      to: sceneEnd("fourMation"),
    },
    {
      color: ERAS[3].color,
      from: SCENES.seniorEra.from,
      to: sceneEnd("seniorEra"),
    },
  ];
  const span = trackEndFrame - trackStart;
  const gradient = `linear-gradient(90deg, ${eraStops
    .map(
      (stop) =>
        `${stop.color} ${(((stop.from - trackStart) / span) * 100).toFixed(
          1
        )}%, ${stop.color} ${(((stop.to - trackStart) / span) * 100).toFixed(1)}%`
    )
    .join(", ")})`;

  const fillPercent =
    interpolate(frame, [trackStart, trackEndFrame], [0, 100], {
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
    });

  return (
    <div
      style={{
        position: "absolute",
        bottom: 36,
        left: 0,
        right: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
        opacity: interpolate(frame, [30, 45, 880, 900], [0, 1, 1, 0], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        }),
        fontFamily: "'JetBrains Mono', monospace",
        color: "#b3b3b3",
        fontSize: 22,
        pointerEvents: "none",
      }}
    >
      <span>2018</span>
      <div
        style={{
          position: "relative",
          width: 640,
          height: 8,
          borderRadius: 4,
          backgroundColor: "#2c2c2c",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: gradient,
            opacity: 0.9,
            clipPath: `inset(0 ${100 - fillPercent}% 0 0)`,
          }}
        />
      </div>
      <span>2026</span>
      <span style={{ color: "#666", fontSize: 18 }}>
        {Math.round((frame / (durationInFrames - 1)) * 100)}%
      </span>
    </div>
  );
};

export default TimelineHUD;
